
export const locale = {
  lang: "ru",
  data: {
    "Logout": "Выйти",
  }
};
